import script from "./AppointmentcancelView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentcancelView.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentcancelView.vue?vue&type=style&index=0&id=3a3b56e0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a3b56e0"]])

export default __exports__